// Author thq
// Date 2021-12-07 09:49:48

import * as model from "@/model/em/statusCollection/EmSicBoardModuleSdmModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSicBoardModuleSdm(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
